import { render, staticRenderFns } from "./whatsappForm.vue?vue&type=template&id=cfa6ee54"
import script from "./whatsappForm.vue?vue&type=script&lang=js"
export * from "./whatsappForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports